import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from './portal/auth.store';

export const authGuard: CanActivateFn = async (_r, s) => {
  const router = inject(Router);
  const authStore = inject(AuthStore);

  const isAuthenticated = await authStore.checkAuth();

  if (isAuthenticated) return true;
  // Carry the originally requested URL so the login page can return the
  // user to it (deep links, "Open in new tab", refresh on a sub-route).
  return router.createUrlTree(['/login'], {
    queryParams: { next: s.url },
  });
};